// Chakra imports
import { Flex, Text, Stack } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import { maskDataHistoricoSemHora } from "config/functions";

export default function Banner(props: {
  saldo: string;
  number: string;
  dataUser: any;
  cartao: any;
  tipo: any;
  qtdSaldo: any;
}) {
  const { saldo, number, dataUser, cartao, tipo, qtdSaldo, ...rest } = props;

  enum TipoStatusCartao {
    EM_USO = "EM_USO",
    PENDENTE_ASSOCIACAO = "PENDENTE_ASSOCIACAO",
    ATIVO = "ATIVO",
    ASSOCIADA = "ASSOCIADA",
    BLOQUEADA_SUSPEITA_FRAUDE = "BLOQUEADA_SUSPEITA_FRAUDE",
    BLOQUEADA = "BLOQUEADA",
    SUSPENSA = "SUSPENSA",
    CANCELADA = "CANCELADA",
    CANCELADA_FISICAMENTE = "CANCELADA_FISICAMENTE",
    GRAVADO = "GRAVADO",
    RESERVADA = "RESERVADA",
    BLOQUEADO_ENTREGA = "BLOQUEADO_ENTREGA",
  }
  const statusCartaoJae = (status: any) => {
    switch (status) {
      case TipoStatusCartao.EM_USO:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Ativo
          </Text>
        );
      case TipoStatusCartao.PENDENTE_ASSOCIACAO:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Pendente de associação
          </Text>
        );
      case TipoStatusCartao.ATIVO:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Ativo
          </Text>
        );
      case TipoStatusCartao.ASSOCIADA:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Cartão em produção
          </Text>
        );
      case TipoStatusCartao.BLOQUEADA:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Bloqueado
          </Text>
        );
      case TipoStatusCartao.SUSPENSA:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Suspenso
          </Text>
        );
      case TipoStatusCartao.CANCELADA:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Cancelado
          </Text>
        );
      case TipoStatusCartao.CANCELADA_FISICAMENTE:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Cancelado fisicamente
          </Text>
        );
      case TipoStatusCartao.GRAVADO:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Gravado
          </Text>
        );
      case TipoStatusCartao.RESERVADA:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Reservado
          </Text>
        );
      case TipoStatusCartao.BLOQUEADO_ENTREGA:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Bloqueado entrega
          </Text>
        );
      case TipoStatusCartao.BLOQUEADA_SUSPEITA_FRAUDE:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            Bloqueado uso indevido
          </Text>
        );
      default:
        return (
          <Text fontSize={{ sm: "md", lg: "md", xl: "md" }} fontWeight="bold">
            {status}
          </Text>
        );
    }
  };
  const statusCartao = (status: any) => {
    switch (status) {
      case 1:
        return window.config.cardContaJae;
      case 2:
        return window.config.cardVt;
      case 3:
        return window.config.cardGratuidade;
      case 4:
        return window.config.cardAvulso;
      case 6:
        return window.config.cardVt;
    }
  };

  return (
    <Card
      backgroundImage={statusCartao(tipo)}
      backgroundRepeat="no-repeat"
      boxShadow="1px 22px 12px -12px rgba(0, 0, 0, 0.4)"
      bgSize="cover"
      alignSelf="center"
      w={{ base: "330px", md: "330px", xl: "330px" }}
      bgPosition="0%"
      h={"180px"}
      sx={
        cartao.descricaoStatusMidia === "CANCELADA" ||
        cartao.descricaoStatusMidia === "BLOQUEADA" ||
        cartao.descricaoStatusMidia === "BLOQUEADA_SUSPEITA_FRAUDE" ||
        cartao.descricaoStatusMidia === "ASSOCIADA" ||
        cartao.descricaoStatusMidia === "BLOQUEADO_ENTREGA" ||
        cartao.descricaoStatusMidia === "PENDENTE_ASSOCIACAO"
          ? { opacity: 0.6 }
          : null
      }
      mx="auto"
      p="0px"
      {...rest}
    >
      <Flex direction="column" color="white" h="100%" w="100%" ml={"18px"}>
        <Flex direction="column">
          <Flex direction="column" alignItems={"start"}>
            <Text
              fontSize={{ sm: "md", lg: "md", xl: "md" }}
              fontWeight="bold"
              mt="1"
            >
              {number}
            </Text>
            <Stack direction={"row"}>
              <Text fontSize={"sm"} mt="0.5" fontWeight="600">
                status:
              </Text>
              {statusCartaoJae(cartao.descricaoStatusMidia)}
            </Stack>
          </Flex>

          <Flex direction="column" align={"left"} mt={"93px"}>
            {cartao.dataAssociacao ? (
              <Text fontSize="sm" fontWeight="600">
                {cartao.idProduto !== 1 ? "Solicitado em: " : "Associado em: "}
                {maskDataHistoricoSemHora(cartao.dataAssociacao)}{" "}
              </Text>
            ) : null}

            {cartao.dataDesassociacao ? (
              <Text fontSize="sm" fontWeight="600">
                Desassociação:{" "}
                {maskDataHistoricoSemHora(cartao.dataDesassociacao)}
              </Text>
            ) : null}
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
